/** 전역 이벤트 이름과 페이로드 타입. PlayerState/Inventory 가 발행하고 UI 가 구독한다. */

export const EV = {
  hpChanged: 'hp-changed',
  mpChanged: 'mp-changed',
  expChanged: 'exp-changed',
  levelUp: 'level-up',
  mesoChanged: 'meso-changed',
  inventoryChanged: 'inventory-changed',
  playerDied: 'player-died',
  playerRespawned: 'player-respawned',
  deathPrompt: 'death-prompt',
  reviveChosen: 'revive-chosen',
  toast: 'toast',
  npcTalk: 'npc-talk',
  questChanged: 'quest-changed',
  shopOpen: 'shop-open',
  gearChanged: 'gear-changed',
  mapChanged: 'map-changed',
  statsChanged: 'stats-changed',
  statusChanged: 'status-changed',
  statusTick: 'status-tick',
  netChat: 'net-chat',
  netParty: 'net-party',
  netStatus: 'net-status',
  netShareExp: 'net-share-exp',
  netFriends: 'net-friends',
  titleChanged: 'title-changed',
  achieveChanged: 'achieve-changed',
} as const;

export interface HpPayload {
  hp: number;
  maxHp: number;
}

export interface MpPayload {
  mp: number;
  maxMp: number;
}

export interface ExpPayload {
  exp: number;
  need: number;
  ratio: number;
  level: number;
}

export interface MesoPayload {
  meso: number;
  delta: number;
}

export interface ToastPayload {
  message: string;
  tone?: 'info' | 'warn' | 'good';
}

export interface NpcTalkPayload {
  npcId: string;
}

export interface ShopOpenPayload {
  shopId: string;
}

export interface DeathPromptPayload {
  lostExp: number;
  exp: number;
  need: number;
}

export type RevivePlace = 'here' | 'town';

export interface ReviveChosenPayload {
  place: RevivePlace;
}

export interface MapChangedPayload {
  mapId: string;
  name: string;
  subtitle: string;
}

export interface StatsChangedPayload {
  unspentAp: number;
  unspentSp: number;
  level: number;
  jobName: string;
}

export interface StatusEffectView {
  id: string;
  name: string;
  icon: string;
  remainMs: number;
}

export interface StatusChangedPayload {
  effects: StatusEffectView[];
}

export interface StatusTickPayload {
  amount: number;
  name: string;
}
